module.exports = __webpack_public_path__ + "fonts/Amaranth-Bold.f934f8aa.woff";